<template>
    <div class="detail">
        <!-- 文章详情banner -->
        <div class="detail-header">
            <!-- <Header></Header> -->
        </div>
        <!-- 文章详情 -->
        <div class="article-detail">
            <!-- 文章内容 -->
            <div class="artcile-info">
                <!-- 图片 -->
                <img
                    class="article-cover"
                    :src="articleInfo.cover"
                    alt=""
                >
                <!-- 信息详情 -->
                <div class="info-detail">
                    <div class="info-title">
                        基本信息
                    </div>
                    <div class="article-common info-serveice">
                        <span class="article-label">服务URL：</span>
                        <span>{{ articleInfo.cover }}</span>
                    </div>
                    <div class="article-common article-name">
                        <span class="article-label">文章名称：</span>
                        <span>{{ articleInfo.title }}</span>
                    </div>
                    <div class="article-common article-content">
                        <span class="article-label">文章内容：</span>
                        <span
                            @click="switchPageToService"
                            v-lazy-container="{ selector: 'img' }"
                            class="
                            content-detail"
                            v-html="replaceAllImg(articleInfo.content)"
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header";
import { getArticleDetailById } from "@/api/source/detail";
export default {
    name: "Detail",
    data() {
        return {
            // content:
            //     '<p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_1.png" alt="影像图片">面积为154344.451161,经度为108.704469697,纬度为34.0030322082,为西安市高新区秦岭北麓违法建筑一期_1,时间为2020-10-01,位置为西安市高新区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_10.png" alt="影像图片">面积为42423.3877835,经度为108.805276691,纬度为34.0339304101,为西安市高新区秦岭北麓违法建筑一期_10,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_11.png" alt="影像图片">面积为148229.817233,经度为108.804419457,纬度为34.0365403235,为西安市高新区秦岭北麓违法建筑一期_11,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_12.png" alt="影像图片">面积为266759.386098,经度为108.813331937,纬度为34.0407711612,为西安市高新区秦岭北麓违法建筑一期_12,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_13.png" alt="影像图片">面积为266207.725481,经度为108.823963442,纬度为34.0436271517,为西安市高新区秦岭北麓违法建筑一期_13,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_14.png" alt="影像图片">面积为252090.706809,经度为108.822422259,纬度为34.0502778731,为西安市高新区秦岭北麓违法建筑一期_14,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_15.png" alt="影像图片">面积为101205.367538,经度为108.831181072,纬度为34.0454544343,为西安市高新区秦岭北麓违法建筑一期_15,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_16.png" alt="影像图片">面积为109106.394381,经度为108.850205594,纬度为34.0476759668,为西安市高新区秦岭北麓违法建筑一期_16,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_2.png" alt="影像图片">面积为81503.1824719,经度为108.719798179,纬度为33.9975658247,为西安市高新区秦岭北麓违法建筑一期_2,时间为2020-10-01,位置为西安市高新区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_3.png" alt="影像图片">面积为121485.770344,经度为108.724864932,纬度为34.0073754517,为西安市高新区秦岭北麓违法建筑一期_3,时间为2020-10-01,位置为西安市高新区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_4.png" alt="影像图片">面积为227081.023455,经度为108.739031166,纬度为34.003712059,为西安市高新区秦岭北麓违法建筑一期_4,时间为2020-10-01,位置为西安市高新区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_5.png" alt="影像图片">面积为115238.952172,经度为108.738753056,纬度为33.9967286765,为西安市高新区秦岭北麓违法建筑一期_5,时间为2020-10-01,位置为西安市高新区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_6.png" alt="影像图片">面积为195258.719,经度为108.763286142,纬度为34.0139991986,为西安市高新区秦岭北麓违法建筑一期_6,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_7.png" alt="影像图片">面积为173018.202828,经度为108.772443765,纬度为34.0169485825,为西安市高新区秦岭北麓违法建筑一期_7,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_8.png" alt="影像图片">面积为257360.550628,经度为108.779585602,纬度为34.0203230962,为西安市高新区秦岭北麓违法建筑一期_8,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p><p><img src="http://zplan.zimax.com.cn/idata/topicDataStorage/fetchByName/西安市高新区秦岭北麓违法建筑一期_9.png" alt="影像图片">面积为115412.162083,经度为108.800816269,纬度为34.031939847,为西安市高新区秦岭北麓违法建筑一期_9,时间为2020-10-01,位置为西安市长安区秦岭北麓,</p>',
            content: "",
            articleInfo: {
                cover: "",
                title: "",
                content: "",
            },
        };
    },
    components: {
        Header,
    },
    computed: {},
    methods: {
        replaceAllImg(html) {
            let newContent = html.replace(
                /<img[^>]*>/gi,
                function (str, capture) {
                    let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
                    let url = str.match(srcReg);
                    let mat = str.replace(
                        /src=\"(.*)\"/gi,
                        "data-src=" + url[1]
                    );
                    return mat;
                }
            );
            return newContent;
        },
        articleResourceDetail(id) {
            getArticleDetailById({ id })
                .then((res) => {
                    const articleDetail = res.data.data;
                    this.articleInfo.cover = articleDetail.cover;
                    this.articleInfo.title = articleDetail.title;
                    this.articleInfo.content = articleDetail.content;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        switchPageToService(event) {
            if (
                event.target.nodeName.toLowerCase() === "div" &&
                event.target.className === "service"
            ) {
                this.$router.push({
                    name: "Service",
                    params: {
                        name: this.articleInfo.title,
                        layer: "shadow_1",
                    },
                });
            }
        },
    },
    mounted() {
        let articleId = this.$route.query.id;
        this.articleResourceDetail(articleId);
    },
};
</script>
<style scoped>
.detail-header {
    height: 86px;
    box-sizing: border-box;
    border: 1px solid transparent;
    background: #262b4f;
    padding-bottom: 20px;
}
.article-detail {
    box-sizing: border-box;
    border: 1px solid transparent;
    background: #f5f5f5;
}
.artcile-info {
    box-sizing: border-box;
    padding: 0 100px;
    width: 1200px;
    margin: auto;
    margin-top: 60px;
    background: #fff;
}
.artcile-info img {
    margin-top: 25px;
    width: 1000px;
}
.info-detail {
    margin-top: 30px;
}
.info-title {
    font-family: "PingFangSC-Semibold, sans-serif";
    font-size: 28px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
}
.article-common {
    padding: 10px 0;
    margin: 10px 0;
}
.article-common span:nth-of-type(2) {
    font-size: 16px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #333;
}
.article-label {
    font-size: 16px;
    line-height: 16px;
    font-family: "PingFangSC-Medium, sans-serif";
    font-weight: 500;
    color: #666666;
}
@import url("../../assets/font/font.css");
</style>
<style>
.detail .content-detail p {
    margin: 20px 0;
}
.detail .content-detail p img {
    box-sizing: border-box;
    border: 1px dashed #888888;
    width: 1000px;
}
.detail .content-detail p {
    font-size: 16px;
    line-height: 36px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #333;
}
</style>